<template>
  <v-app id="vueapp">
    <v-navigation-drawer
      v-model="drawer"
      color="black"
      app
      class="noprint"
    >
      <v-row justify="center" class="ma-3">
        <v-img
        justify="center"
        :aspect-ratio="1"
        max-height="150"
        max-width="150"
        src="../src/assets/img/logo_don_notario.svg"
        alt="Logo don Notario"
        ></v-img>
      </v-row>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3 title text-center grey--text text-subtitle-1">
            Herencias y Bienes Raíces
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          to="/"
          link
          class="red--text"
          @click="volver"
        >
          <v-list-item-icon>
            <v-icon>mdi-calculator</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calculadora</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.to"
          link
          class="red--text"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="black"
      dense
      src="../src/assets/img/background.jpg"
      class="noprint"
    >
      <template v-slot:img="{ props }" class="noprint">
        <v-img
          v-bind="props"
        ></v-img>
      </template>

      <v-app-bar-nav-icon aria-hidden="false" aria-label="menu" @click="drawer = !drawer" class="white--text noprint"></v-app-bar-nav-icon>

      <v-app-bar-title class="font-weight-bold white--text noprint">Calculadora Notarial</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-btn aria-hidden="false" icon class="mr-3">
        <v-icon
        aria-hidden="false"
        aria-label="compartir"
        class="white--text noprint"
        @click="share"
        >
        mdi-share-variant
        </v-icon>
      </v-btn>

    </v-app-bar>
    
    <v-main class="vmainprintstyle">
      <v-container class="pa-5">
        <transition name="slide" mode="out-in">
        <router-view v-bind:variables="variables"></router-view>
        </transition>
      </v-container>
    </v-main>

  </v-app>
</template>

<style scoped>
  .slide-enter-active,
  .slide-leave-active {
    transition: opacity 0.2s, transform 0.2s;
  }
  .slide-enter,
  .slide-leave-to {
    opacity: 0;
    transform: translateX(-5%);
  }
  @media print {
      .noprint {
        display: none;
      }
      .vmainprintstyle {
        padding: 0 !important;
        margin: auto;
      }
  }
</style>

<script>
  export default {
    data: () => ({
      drawer: null,
      items: [
        { title: '¿Quiénes somos?', icon: 'mdi-help-box', to: '/about' },
        { title: 'Instrucciones', icon: 'mdi-text-box', to: '/instrucciones' },
      ],
      variables: {
        tiponegocio: '',
        valornegocio: '',
        aranceles: 'true',
        estudiodetitulo: 'true',
        porciento: 1.0,
        rentasinternasoriginal: 0,
        asistencialegaloriginal: 0,
        rentasinternascopia: 0,
        asistencialegalcopia: 0,
        totalarancelesescritura: 0,
        comprobantepresentacion: 0,
        presentaciontelematica: 0,
        rentasinternaspresentacion: 0,
        comprobanteinscripcion: 0,
        totalarancelesregistro: 0,
        honorariosnotariales: 0,
        precioestudiodetitulo: 75,
        totalhonorarios: 0,
        totalpartidas: 0,
        costototal: 0,
        alerta: false,
        alerta2: false,
      },
    }),
    methods: {
      share () {
        if (navigator.share) {
          navigator.share({
            title: 'Calculadora Notarial - Don Notario',
            url: 'https://ortizmorales.com/calculadora-notarial/index.html'
          }).then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(console.error);
        } else {
          // fallback
          var inputc = document.body.appendChild(document.createElement("input"));
          inputc.value = window.location.href;
          inputc.focus();
          inputc.select();
          document.execCommand('copy');
          inputc.parentNode.removeChild(inputc);
          alert("Se copió la dirección de la página. Ahora puede compartirla pegándola en su mensaje (paste).");
        }
      },
      volver () {
        this.variables.alerta = false
        this.variables.alerta2 = false
        this.$router.push('/');
      },
    },
  }
</script>


<!--
CAMBIAR: url: 'https://codepen.io/ayoisaiah/pen/YbNazJ' POR EL URL DE LA CALCULADORA PUBLICADA
-->